import { AccountApi } from '@/api/account.api';
import { NaluriChatError } from '@/errors';
import { CoachProfile } from '@/types';
import { CoachListFilters } from '@/types/gateway';
import { ApiClient } from '@/utils/apiClient';
import { urlAppendSearchParams } from '@/utils/url';

import version from '@/utils/version';
const API_KEY_HEADER = 'x-api-key';

export interface GatewayApiOptions {
  apiUrl: string;
  apiKey: string;
  accountApi: AccountApi;
  timeoutMs?: number;
  onRefreshTokenError?: () => void | Promise<void>;
}

export class GatewayApi {
  private readonly apiUrl: string;
  private readonly apiKey: string;
  private readonly accountApi: AccountApi;
  private onRefreshTokenError?: () => Promise<void>;

  constructor(opts: GatewayApiOptions) {
    Object.assign(this, opts);
  }

  async getCoachList(filters?: CoachListFilters) {
    const apiClient = new ApiClient(this.accountApi, this.onRefreshTokenError);

    const url = urlAppendSearchParams(`${this.apiUrl}/entitlement/coach-list`, {
      userId: this.accountApi.getUserId(),
      reference: this.accountApi.getUserReference(),
      ...filters,
    });

    const response = await apiClient.fetch(url, {
      method: 'GET',
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new NaluriChatError({
        code: '4004',
        message: 'Failed to get coaches',
      });
    }

    const data = (await response.json()) as CoachProfile[];
    return data;
  }

  protected getHeaders() {
    return {
      [API_KEY_HEADER]: this.apiKey,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'User-Agent': `Naluri Chat SDK /JS (${version}})`,
      'x-nl-sdk-version': version,
    };
  }
}
